"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IgnoreTrackingChecklistStepRequestT = exports.IgnoreTrackingChecklistStepRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const tracking_checklist_step_id_js_1 = require("../../solarxr-protocol/rpc/tracking-checklist-step-id.js");
class IgnoreTrackingChecklistStepRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsIgnoreTrackingChecklistStepRequest(bb, obj) {
        return (obj || new IgnoreTrackingChecklistStepRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsIgnoreTrackingChecklistStepRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new IgnoreTrackingChecklistStepRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    stepId() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : tracking_checklist_step_id_js_1.TrackingChecklistStepId.UNKNOWN;
    }
    ignore() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startIgnoreTrackingChecklistStepRequest(builder) {
        builder.startObject(2);
    }
    static addStepId(builder, stepId) {
        builder.addFieldInt8(0, stepId, tracking_checklist_step_id_js_1.TrackingChecklistStepId.UNKNOWN);
    }
    static addIgnore(builder, ignore) {
        builder.addFieldInt8(1, +ignore, +false);
    }
    static endIgnoreTrackingChecklistStepRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createIgnoreTrackingChecklistStepRequest(builder, stepId, ignore) {
        IgnoreTrackingChecklistStepRequest.startIgnoreTrackingChecklistStepRequest(builder);
        IgnoreTrackingChecklistStepRequest.addStepId(builder, stepId);
        IgnoreTrackingChecklistStepRequest.addIgnore(builder, ignore);
        return IgnoreTrackingChecklistStepRequest.endIgnoreTrackingChecklistStepRequest(builder);
    }
    unpack() {
        return new IgnoreTrackingChecklistStepRequestT(this.stepId(), this.ignore());
    }
    unpackTo(_o) {
        _o.stepId = this.stepId();
        _o.ignore = this.ignore();
    }
}
exports.IgnoreTrackingChecklistStepRequest = IgnoreTrackingChecklistStepRequest;
class IgnoreTrackingChecklistStepRequestT {
    constructor(stepId = tracking_checklist_step_id_js_1.TrackingChecklistStepId.UNKNOWN, ignore = false) {
        this.stepId = stepId;
        this.ignore = ignore;
    }
    pack(builder) {
        return IgnoreTrackingChecklistStepRequest.createIgnoreTrackingChecklistStepRequest(builder, this.stepId, this.ignore);
    }
}
exports.IgnoreTrackingChecklistStepRequestT = IgnoreTrackingChecklistStepRequestT;
